module.exports = __webpack_public_path__ + "static/seamless-2f3b5b865bb7681e732779d59fe77524.png";